import { render } from "./ModulInfoText2Spaltig.vue?vue&type=template&id=7413e14a"
import script from "./ModulInfoText2Spaltig.vue?vue&type=script&lang=js"
export * from "./ModulInfoText2Spaltig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__